import React from "react";
import ScrollBar from "react-perfect-scrollbar";

function ReactTable({
  getTableProps,
  headerGroups,
  getTableBodyProps,
  prepareRow,
  rows,
  sort = false,
  apiSort = false,
  sticky = false,
  bodySpace = false,
  tableHeigth,
}) {
  return (
    <div id="react-table" className={sticky ? "sticky" : ""}>
      <ScrollBar style={{ height: tableHeigth && `${tableHeigth}px` }}>
        <table {...getTableProps()} className="w-100">
          <thead className="thead">
            {headerGroups.map((headerGroup, index) => (
              <tr
                className="table-header-items tr"
                {...headerGroup.getHeaderGroupProps()}
                key={index}
              >
                {headerGroup.headers.map((column) => (
                  <th
                    className="th"
                    {...column.getHeaderProps(
                      (sort && !apiSort) && column.getSortByToggleProps()
                    )}
                    
                  >
                    <div className={apiSort ? 'pointer' : ''} onClick={() => apiSort && apiSort(column.id) }>
                      {column.render("Header")}

                      {sort && (
                        <>
                          {column.isSorted ? (
                            column.isSortedDesc ? (
                              <i className="las la-sort"></i>
                            ) : (
                              <i className="las la-sort"></i>
                            )
                          ) : (
                            <i className="las la-sort"></i>
                          )}
                        </>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            {...getTableBodyProps()}
            className={`tbody ${bodySpace ? "space-body" : ""}`}
          >
            {/* <ScrollBar> */}
            {rows.map((row, index) => {
              prepareRow(row);
              return (
                <tr className="tr" key={index} {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} className="td">
                        <div>{cell.render("Cell")}</div>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
            {/* </ScrollBar>k */}
          </tbody>
        </table>
      </ScrollBar>
    </div>
  );
}

export default ReactTable;
